import { classes, getTargets, parseHTML } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

if (!customElements.get('main-blog'))
  customElements.define(
    'main-blog',
    class MainBlog extends HTMLCustomElement {
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();

        this.on('click', this.targets.previous, (event) => {
          event.preventDefault();

          this.targets.previous.classList.add(classes.disabled);

          this.fetch(event.target.href, true).then(({ previous }) => {
            if (previous) {
              this.targets.previous.href = previous.href;
            } else {
              this.targets.previous.remove();
            }

            this.targets.previous.classList.remove(classes.disabled);
          });
        });

        this.on('click', this.targets.next, (event) => {
          event.preventDefault();

          this.targets.next.classList.add(classes.disabled);

          this.fetch(event.target.href).then(({ next }) => {
            if (next) {
              this.targets.next.href = next.href;
            } else {
              this.targets.next.remove();
            }

            this.targets.next.classList.remove(classes.disabled);
          });
        });
      }

      /**
       * Fetches and updates the grid.
       * @param {String} url - The page url.
       * @param {Boolean} prepend - Prepends the content to the grid.
       * @returns {Promise}
       */
      async fetch(url, prepend = false) {
        const fetchUrl = new URL(url);

        fetchUrl.searchParams.append('section_id', 'main-blog');

        return fetch(fetchUrl.toString())
          .then((response) => response.text())
          .then((response) => {
            const html = parseHTML(response, this.tagName.toLowerCase());
            const { grid, next, previous } = getTargets(html);
            const currentPage = parseInt(fetchUrl.searchParams.get('page'));

            if (prepend) {
              this.targets.grid.innerHTML = `${grid.innerHTML}${this.targets.grid.innerHTML}`;
            } else {
              this.targets.grid.innerHTML = `${this.targets.grid.innerHTML}${grid.innerHTML}`;
            }

            /**
             * Update the current query parameter.
             */
            this.setPageQueryParameter(currentPage);

            return {
              previous,
              next,
            };
          });
      }

      /**
       * Sets the current page query parameter.
       * @param {Number} page - The page number to set.
       */
      setPageQueryParameter(page) {
        const { pathname, hash, searchParams } = new URL(window.location.href);

        if (page <= 1) {
          searchParams.delete('page');
        } else {
          searchParams.set('page', page);
        }

        window.history.replaceState(
          null,
          '',
          `${pathname}${searchParams.size ? `?${searchParams.toString()}${hash}` : ''}`
        );
      }
    }
  );
